import * as React from 'react';
import { ArticleListPagerBtn } from './article-list-pager-btn';

export interface IArticleListPagerProps {
    totalPages: number,
    currentPage: number,
    prevBtnHandler(): void,
    nextBtnHandler(): void,
    pageBtnHander(page: number): void
}

type Mode = 'none' | 'start' | 'middle' | 'end';

export class ArticleListPager extends React.Component<IArticleListPagerProps, {}>{    

    private get separator(): JSX.Element {
        return <small>...</small>;
    }

    private getDisplayObj(): { mode: Mode, pages: Array<number> } {

        if (this.props.totalPages < 6) {
            const pages = new Array<number>();
            let page = 1;
            while (page <= this.props.totalPages) {
                pages.push(page);
                page = page + 1;
            } 
            return { mode: 'none', pages: pages };
        }

        const frontCheck: number = 3;
        const backCheck: number = this.props.totalPages - 3;

        if (this.props.currentPage <= 3) {
            return { mode: 'start', pages: [1, 2, 3, 4] };
        }
        else if (this.props.currentPage >= backCheck) {
            return {
                mode: 'end',
                pages: [
                    this.props.totalPages - 3,
                    this.props.totalPages - 2,
                    this.props.totalPages - 1,
                    this.props.totalPages
                ]
            };
        }
        else {
            return {
                mode: 'middle',
                pages: [
                    this.props.currentPage - 1,
                    this.props.currentPage,
                    this.props.currentPage + 1
                ]
            };
        }
    }


    private getPageBtns(): Array<JSX.Element> {

        const displayObj = this.getDisplayObj();
        const pageBtns = new Array<JSX.Element>();

        if (displayObj.mode === 'none') {
            return displayObj.pages.map((page: number) => {
                return <ArticleListPagerBtn key={page} page={page}
                    isActive={this.props.currentPage === page} pageBtnHandler={this.props.pageBtnHander} />;
            });
        }

        if (displayObj.mode === 'middle' || displayObj.mode === 'end') {
            pageBtns.push(<ArticleListPagerBtn
                key={1} page={1} isActive={false} pageBtnHandler={this.props.pageBtnHander} />);
            pageBtns.push(this.separator);
        }

        displayObj.pages.forEach((page: number) => {
            const isActive: boolean = this.props.currentPage === page;
            pageBtns.push(<ArticleListPagerBtn
                key={page} page={page} isActive={isActive} pageBtnHandler={this.props.pageBtnHander} />);
        });

        if (displayObj.mode === 'middle' || displayObj.mode == 'start') {
            pageBtns.push(this.separator);
            pageBtns.push(<ArticleListPagerBtn
                key={this.props.totalPages} page={this.props.totalPages} isActive={false} pageBtnHandler={this.props.pageBtnHander} />);
        }

        return pageBtns;
    }


    render() {
        return (
            <div className="pagination">
                <div className={'pagination-prev' + (this.props.currentPage === 1 ? ' disabled' : '')}>
                    <small className="pagination-prev-text" onClick={this.props.prevBtnHandler}>
                        Previous
                    </small>
                </div>
                <div className="pagination-pages">{this.getPageBtns()}</div>
                <div className={'pagination-next' + (this.props.currentPage === this.props.totalPages ? ' disabled' : '')}>
                    <small className="pagination-next-text" onClick={this.props.nextBtnHandler}>
                        Next
                    </small>
                </div>
            </div>    
        );
    }
}


// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/shared/article-list-pager.tsx